import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, filter, map, mergeMap, of } from 'rxjs';
import { textActions } from '../actions/text.actions';
import { selectLoading } from '../selectors/text.selector';
import { HttpService } from '../services/http.service';

@Injectable()
export class TextEffects {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getText$ = createEffect(() => {
        return this.actions.pipe(
            ofType(textActions.getText),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            mergeMap(([action]) => {
                return this.httpService.getText(action.id).pipe(
                    map((payload) => textActions.getTextSuccess({ payload })),
                    catchError((error) => of(textActions.getTextError({ id: action.id, code: error.status }))),
                );
            }),
        );
    });

    getTextSetLoading$ = createEffect(() => {
        return this.actions.pipe(
            ofType(textActions.getText),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            map(([action]) => textActions.setLoading({ id: action.id })),
        );
    });
}
